import { NextSeo } from 'next-seo';
import React from 'react';
import PageHeader from '../components/PageHeader';
import TheAdventuresPage from '../components/TheAdventuresPage';
import config from '../config';

function AdventuresPage() {
  const title = `Shitty Adventures - ${config.siteName}`;
  const description = `Go on adventures to earn Shitty Kitty Treats and other rewards.`;

  return (
    <>
      <NextSeo title={title} description={description} />
      <div className='pb-12 md:pb-48 bg-bg'>
        <PageHeader
          heading={'Shitty Adventures'}
          description='Go on adventures to earn Shitty Kitty Treats and other rewards.'
          docsLink='https://docs.shittykitties.art/website-utilities/shitty-adventures'
        />
        <div className='px-4 max-w-7xl lg:mx-auto lg:px-8'>
          <TheAdventuresPage />
        </div>
      </div>
    </>
  );
}

export default AdventuresPage;
